export const accountLinkerUrls = {
  getLinkedProfiles: 'CounterpartyLinkedProfiles',
  requestLinkToCounterpartyProfile: 'CounterpartyLinkedProfile/{identificator}',
  acceptRequestForLinking: 'AcceptForCounterpartyLinkProfile/{requestForLinkingId}',
  declineRequestForLinking: 'DeclineForCounterpartyLinkProfile/{requestForLinkingId}',
  getTokenForLinkedAccount: 'GiveAuthorizationTokenForLinkedProfile/{requestForLinkingId}',
};
